import { Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import NavigationProvider from "./contentApi/navigationProvider";

import "./sidenav.css";
import "./header.css";
import "./guests.css";
import "./home.css";
import "./table.css";
import "./resetpassword.css";
import "./packagedetails.css";
import "./leaddetails.css";
import "./App.css";
import "./footer.css";


import Login from "./Components/Login";
import Signup from "./Components/register";
import Forgotpassword from "./Components/forgotpassword";
import OtpVerify from "./Components/otpverify";
import ResetPassword from "./Components/resetpassword";



import ProtectedRoutes from "./Components/ProtectedRoutes";
import PublicRoutes from "./Components/PublicRoutes";

//travel admin
import Home from "./Components/admin/Home";

import Expense from "./Components/admin/expense";
import AddExpense from "./Components/admin/addExpense";
import EditExpense from "./Components/admin/editExpense";
import Calendar from "./Components/admin/calendar";

import AddActivity from "./Components/admin/addactivity";
import Activity from "./Components/admin/activity";
import EditActivity from "./Components/admin/editactivity";

import AddVendor from "./Components/admin/addvendor";
import Vendor from "./Components/admin/vendors";
import EditVendor from "./Components/admin/editvendor";

import Leads from "./Components/admin/leads";
import AddLeads from "./Components/admin/addleads";
import EditLead from "./Components/admin/editlead";


import Packages from "./Components/admin/Packages";
import AddPackages from "./Components/admin/addPackage";
import Packagedetails from "./Components/admin/packagedetails";
import CopyPackages from "./Components/admin/copyPackage";

import Hotels from "./Components/admin/hotels";
import Addhotel from "./Components/admin/addhotel";
import EditHotel from "./Components/admin/edithotel";
import Hoteldetails from "./Components/admin/hoteldetails";
import Rooms from "./Components/admin/Rooms";

import Guests from "./Components/admin/guests";
import Profile from "./Components/admin/Profile";

import BookingDetails from "./Components/admin/bookingdetails";
import Bookings from "./Components/admin/bookings";

import Staff from "./Components/admin/staff";
import EditStaff from "./Components/admin/editStaff.";
import AddStaff from "./Components/admin/addstaff";

import EnquiryTable from "./Components/admin/enquiry";

import AddPlaces from "./Components/admin/addPlace";
import EditPlace from "./Components/admin/editPlace";
import Places from "./Components/admin/places";

import Category from "./Components/admin/category";
import AddCategory from "./Components/admin/addCategory";
import EditCategory from "./Components/admin/editCategory";

import Bedtype from "./Components/admin/bedtype";
import AddBedType from "./Components/admin/addbedtype";
import EditBedtype from "./Components/admin/editbedtype";

import Vehicle from "./Components/admin/vehicle";
import AddVehicle from "./Components/admin/addVehicle";
import EditVehicle from "./Components/admin/editVehicle";

import Roomtype from "./Components/admin/roomtype";
import AddRoomType from "./Components/admin/addroomtype";
import Editroomtypes from "./Components/admin/editroomtype";

import Ferry from "./Components/admin/ferry";
import Addferrys from "./Components/admin/addFerry";
import EditFerry from "./Components/admin/editFerry";

import HotelRooms from "./Components/admin/hotelRooms";
import AdminDashboardlayout from "./Components/admin/admindashboardlayout";
import AdminLogin from "./Components/adminLogin";

import LeadDetails from "./Components/admin/leadDetails";
import ChangePassword from "./Components/ChangePassword";
import EditQuotation from "./Components/admin/editQuotation";

// superadmin   -- >
import SadminHome from "./Components/superadmin/Home";
import SuperadminDashboardlayout from "./Components/superadmin/superadmindashboardlayout";
import Organization from "./Components/superadmin/organization";
import AddOrganization from "./Components/superadmin/addOrganization";
import EditOrganization from "./Components/superadmin/editOrganization";
import Amenities from './Components/superadmin/amenity';
import AddAmenities from './Components/superadmin/addamenity';
import EditAmenities from './Components/superadmin/editamenity';

// Hotel 
import Hoteladminboardlayout from "../src/Components/hotel/admindashboardlayout"
import HotelHome from "../src/Components/hotel/Home"

import HoteladminVendorlist from "./Components/hotel/vendorlist";
import HoteladminAddVendor from "./Components/hotel/addvendor";
import HoteladminEditVendor from "./Components/hotel/editvendor";

import HoteladminRoomtype from "./Components/hotel/roomtype";
import Hoteladminhotelrooms from "./Components/hotel/hotelRooms";
import HoteladminAddRoomType from "./Components/hotel/addroomtype";
import HoteladminEditroomtypes from "./Components/hotel/editroomtype";

import HoteladminAddPlaces from "./Components/hotel/addPlaces";
import HoteladminEditPlace from "./Components/hotel/editPlace";
import HoteladminPlaces from "./Components/hotel/places";

import HoteladminHotellist from "./Components/hotel/hotellist";
import HoteladminAddhotellist from "./Components/hotel/addhotellist";
import HoteladminEditHotelList from "./Components/hotel/edithotellist";

import HoteladminLeads from "./Components/hotel/leads";
import HoteladminAddLeads from "./Components/hotel/addleads";
import HoteladminEditLead from "./Components/hotel/editlead";
import HoteladminLeaddetails from "./Components/hotel/leadDetails";

import HoteladminStafflist from "./Components/hotel/stafflist";
import HoteladminEditStaff from "./Components/hotel/editStaff.";
import HoteladminAddStaff from "./Components/hotel/addstaff";

import HoteladminExpense from "./Components/hotel/expense";
import HoteladminAddExpense from "./Components/hotel/addExpense";
import HoteladminEditExpense from "./Components/hotel/editExpense";

import CreateQuotation from "./Components/admin/CreateQuotation";
import QuotationPreview from "./Components/admin/QuotationPreview";

import HotelAdminprofile from "./Components/hotel/Profile";

import Agents from "./Components/admin/agents";
import AddAgent from './Components/admin/addAgent';
import EditAgent from "./Components/admin/editAgent";
import InvoicePreview from "./Components/admin/invoicePreview";



export default function App() {
  return (
    <NavigationProvider>

      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop closeOnClick pauseOnHover />

      <Routes>

        {/* ---- > Public Router */}
        <Route path="/" element={<PublicRoutes />}>

          <Route index element={<Login />} />
          <Route path="login" element={<Login />} />
          <Route path="signup" element={<Signup />} />
          <Route path="admin-login" element={<AdminLogin />} />

          <Route path="/forgotpassword" element={<Forgotpassword />} />
          <Route path="/verify-otp" element={<OtpVerify />} />
          <Route path="/resetpassword" element={<ResetPassword />} />
          <Route path="/changepassword" element={<ChangePassword />} />

        </Route>


        {/* admin pages === >  */}
        <Route path="/admin" element={<ProtectedRoutes />}>
          <Route element={<AdminDashboardlayout />}>
            <Route path="home" element={<Home />} />
            <Route path="hotels" element={<Hotels />} />
            <Route path="rooms" element={<Rooms />} />

            <Route path="profile" element={<Profile />} />

            <Route path="addactivity" element={<AddActivity />} />
            <Route path="activity" element={<Activity />} />
            <Route path="editactivity/:id" element={<EditActivity />} />
            <Route path="lead-details/:id" element={<LeadDetails />} />

            <Route path="packages" element={<Packages />} />

            <Route path="addpackages" element={<AddPackages />} />
            <Route path="editpackage/:id" element={<AddPackages />} />
            <Route path="copypackage/:id" element={<CopyPackages />} />
            <Route path="addhotel" element={<Addhotel />} />
            <Route path="edithotel/:id" element={<EditHotel />} />

            <Route path="vehicle" element={<Vehicle />} />
            <Route path="addvehicle" element={<AddVehicle />} />
            <Route path="editvehicle/:id" element={<EditVehicle />} />

            <Route path="vendor" element={<Vendor />} />
            <Route path="addvendor" element={<AddVendor />} />
            <Route path="editvendor/:id" element={<EditVendor />} />

            <Route path="agent" element={<Agents />} />
            <Route path="addagent" element={<AddAgent />} />
            <Route path="editagent/:id" element={<EditAgent />} />

            <Route path="lead" element={<Leads />} />
            <Route path="addlead" element={<AddLeads />} />
            <Route path="editlead/:id" element={<EditLead />} />


            <Route path="expense" element={<Expense />} />
            <Route path="addexpense" element={<AddExpense />} />
            <Route path="editexpense/:id" element={<EditExpense />} />

            <Route path="calendar" element={<Calendar />} />

            <Route path="packagedetails/:id" element={<Packagedetails />} />
            <Route path="hoteldetails/:id" element={<Hoteldetails />} />

            <Route path="guests" element={<Guests />} />

            <Route path="booking-details/:id" element={<BookingDetails />} />
            <Route path="booking" element={<Bookings />} />

            <Route path="staff" element={<Staff />} />
            <Route path="addstaff" element={<AddStaff />} />
            <Route path="editstaff/:id" element={<EditStaff />} />

            <Route path="enquiry" element={<EnquiryTable />} />
            <Route path="places" element={<Places />} />
            <Route path="edit-place/:id" element={<EditPlace />} />
            <Route path="addplace" element={<AddPlaces />} />
            <Route path="create-quotation/:id" element={<CreateQuotation />} />
            <Route path="quotation/:id/preview" element={<QuotationPreview />} />
            <Route path="invoice/:id/preview" element={<InvoicePreview />} />
            <Route path="edit-quotation/:id" element={<EditQuotation />} />
            <Route path="category" element={<Category />} />
            <Route path="addcategory" element={<AddCategory />} />
            <Route path="editcategory/:id" element={<EditCategory />} />

            <Route path="ferry" element={<Ferry />} />
            <Route path="add-ferry" element={<Addferrys />} />
            <Route path="edit-ferry/:id" element={<EditFerry />} />

            <Route path="bedtype" element={<Bedtype />} />
            <Route path="addbed-type" element={<AddBedType />} />
            <Route path="editbed-type" element={<EditBedtype />} />

            <Route path="roomtype" element={<Roomtype />} />
            <Route path="hotel-rooms/:id" element={<HotelRooms />} />
            <Route path="addroom-type/:id" element={<AddRoomType />} />
            <Route path="editroom-type/:id" element={<Editroomtypes />} />
          </Route>
        </Route>

        {/* hotel pages */}
        <Route path="/hotel" element={<ProtectedRoutes />}>
          <Route element={<Hoteladminboardlayout />}>

            <Route path="home" element={<HotelHome />} />

            <Route path="vendor" element={<HoteladminVendorlist />} />
            <Route path="addvendor" element={<HoteladminAddVendor />} />
            <Route path="editvendor/:id" element={<HoteladminEditVendor />} />

            <Route path="hotellist" element={<HoteladminHotellist />} />
            <Route path="addhotellist" element={<HoteladminAddhotellist />} />
            <Route path="edithotellist/:id" element={<HoteladminEditHotelList />} />

            <Route path="places" element={<HoteladminPlaces />} />
            <Route path="addplace" element={<HoteladminAddPlaces />} />
            <Route path="edit-place/:id" element={<HoteladminEditPlace />} />

            <Route path="roomtype" element={<HoteladminRoomtype />} />
            <Route path="hotel-rooms/:id" element={<Hoteladminhotelrooms />} />
            <Route path="addroom-type/:id" element={<HoteladminAddRoomType />} />
            <Route path="editroom-type/:id" element={<HoteladminEditroomtypes />} />

            <Route path="lead" element={<HoteladminLeads />} />
            <Route path="addlead" element={<HoteladminAddLeads />} />
            <Route path="editlead/:id" element={<HoteladminEditLead />} />
            <Route path="leaddetails/:id" element={<HoteladminLeaddetails />} />

            <Route path="staff" element={<HoteladminStafflist />} />
            <Route path="addstaff" element={<HoteladminAddStaff />} />
            <Route path="editstaff/:id" element={<HoteladminEditStaff />} />

            <Route path="expense" element={<HoteladminExpense />} />
            <Route path="addexpense" element={<HoteladminAddExpense />} />
            <Route path="editexpense/:id" element={<HoteladminEditExpense />} />


            <Route path="profile" element={<HotelAdminprofile />} />



          </Route>
        </Route>

        {/*  Super admin Hotel pages  < ==== */}

        <Route path="/superadmin" element={<ProtectedRoutes />}>
          <Route element={<SuperadminDashboardlayout />}>
            <Route path="home" element={<SadminHome />} />

            {/* amenity -> */}
            <Route path="amenity" element={<Amenities />} />
            <Route path="addamenity" element={<AddAmenities />} />
            <Route path="editamenity/:id" element={<EditAmenities />} />

            {/* organization */}

            <Route path="organization" element={<Organization />} />
            <Route path="addorganization" element={<AddOrganization />} />
            <Route path="editorganization/:id" element={<EditOrganization />} />

          </Route>

        </Route>



      </Routes>
    </NavigationProvider>
  );
}
